import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment.prod';

const host = window.location.hostname;

// Generar URLs dinámicamente
environment.base = `https://${host}`;
environment.baseAvatar = `https://${host}/assets/avatar/`;
environment.baseUrl = `https://back-${host}/backend`;
// environment.baseUrl = `https://${host}/backend`;

// environment.base = `https://desarrollo.becompliance.tech`;
// environment.baseAvatar = `https://desarrollo.becompliance.tech/assets/avatar/`;
// environment.baseUrl = `https://back-${host}/backend`;
// environment.baseUrl = `https://desarrollo.becompliance.tech/backend`;

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
